import AiCatalystSidebar from './AiCatalystSidebar'

export default AiCatalystSidebar
